export enum AnhangUploadStatusEnum {
    IN_BEARBEITUNG = 'IN_BEARBEITUNG',
    ZUGEORDNET = 'ZUGEORDNET',
    FEHLER = 'FEHLER'
}

export interface UploadStatus {
    status: AnhangUploadStatusEnum;
    fehler_id?: string,
    kurztext?: string,
    langtext?: string
}